// extracted by mini-css-extract-plugin
module.exports = {"privacyWrapper":"PrivacyModal_privacyWrapper__235Bs","privacyBody":"PrivacyModal_privacyBody__3g__A","privacyHTML":"PrivacyModal_privacyHTML__2K6h-"};